import { Component, OnInit } from '@angular/core';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { ActivatedRoute } from '@angular/router';
import { stateConstant } from '../../../../constants';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';

declare var $: any;
@Component({
  selector: 'account',
  templateUrl: 'account.component.html'
})

export class AccountComponent implements OnInit {
  isLoader: boolean = false;
  formClass: string = "";
  resultData = [];
  error: string = "";
  siteSource: string = "workflow";
  siteSrc: string = "";
  errormsg: any[] = new Array();
  errdisplay: boolean = false;
  collegeName = [];
  ranks = [];
  zipclass= "";
  trackingName = "Account";
  states: any[] = stateConstant;


  constructor(private _services: ServiceInterface, public _parent: PworkflowComponent, public activatedRoute: ActivatedRoute, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) { }

  async ngOnInit() {
    if(this._parent.campaignName){
      this.trackingName = this._parent.campaignName+" - Account";
    }
    
    this.ranks = await this._services.get("/collegerank/ranklist")
    var elmnt = document.getElementById("top");
    elmnt.scrollIntoView();
    let params: any = this.activatedRoute.snapshot.params;
    if (params.campaign) {
      this.siteSource = params.campaign;
    }
    this.siteSrc = window.location.href;
    //console.log("Source:",this.siteSource);
    if (this._parent.model.passedIn_college_id) {
      this.collegeName = await this._services.get('/search/match/college/' + this._parent.model.passedIn_college_id)
    }
    this.setMilitaryRank();
    this.setMosData();
    let checkMS = this.militaryStatusInfo(this._parent.model.military_status);
    if(checkMS == -1){
      this.zipclass = "col-lg-6";
      $('#rankPaygrade').show();
    }else{
      this.zipclass = "col-lg-12";
      $('#rankPaygrade').hide();
    }

    this.states = this.states.filter(xx => xx.value != 'Online');
  }

  militaryStatusInfo(val){
    let militaryStatusValue = ["Spouse","Dependent","Other"];
    let checkMS = militaryStatusValue.indexOf(val);
    return checkMS;
  }

  setMilitaryRank() {
    let otherMilitaryBranch_id = ["20", "21"];
    let military_branch = this._parent.model.military_branch;
    military_branch = JSON.stringify(military_branch);
    if (otherMilitaryBranch_id.indexOf(military_branch) == -1) {
      if (!this._parent.model.military_rank) {
        $("#rankid").removeClass('ng-valid');
        $("#rankid").addClass('ng-invalid');
      }
    } else {
      $("#rankid").removeClass('ng-invalid');
      this._parent.model.military_rank = "";
    }
  }

  setMosData(){
    let check = this.militaryStatusInfo(this._parent.model.military_status);
    if(check == -1 && !this._parent.model.mos){
      $("#mosid").removeClass('ng-valid');
      $("#mosid").addClass('ng-invalid');
    }else{
      $("#mosid").removeClass('ng-invalid');
    }
  }

  selectMilitaryRank() {
    $("#rankid").removeClass('ng-invalid');
    $("#rankid").addClass('ng-valid');
  }

  clickMosData(){
    $("#mosid").removeClass('ng-invalid');
    $("#mosid").addClass('ng-valid');
  }

  clickSubmit(valid) {
    let checkValid:boolean = true;
    this.errormsg = [];
    let checkMS = this.militaryStatusInfo(this._parent.model.military_status);
    if(checkMS == -1 && !(this._parent.model.military_rank)){
      checkValid = false;
    }
    
    if (valid && checkValid) {
      this.accountsubmit();
      this.error = "";
    } else {
      //let filter = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      let filter = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      if (!(this._parent.model.first_name)) {
        this.errdisplay = true;
        this.errormsg.push("Please enter first name.");
      }
      if((this._parent.model.first_name) &&  /\b\d*test\d*\b/gi.test(this._parent.model.first_name)){
        this.errdisplay = true;
        this.errormsg.push("First name may not contain the word 'test'.");
      }
      if (!(this._parent.model.last_name)) {
        this.errdisplay = true;
        this.errormsg.push("Please enter last name.");
      }
      
      if((this._parent.model.last_name) &&  /\b\d*test\d*\b/gi.test(this._parent.model.last_name)){
        this.errdisplay = true;
        this.errormsg.push("Last name may not contain the word 'test'.");
      }
      if (!(this._parent.model.military_rank)) {
        let otherMilitaryBranch_id = ["20", "21"];
        let military_branch = this._parent.model.military_branch;
        military_branch = JSON.stringify(military_branch);
        if ((otherMilitaryBranch_id.indexOf(military_branch) == -1) && checkMS == -1) {
          $("#rankid").removeClass('ng-valid');
          $("#rankid").addClass('ng-invalid');
          this.errdisplay = true;
          this.errormsg.push("Please select paygrade.");
        } else {
          $("#rankid").removeClass('ng-invalid');
        }
      }
      /*if (!(this._parent.model.mos) && checkMS == -1) {
        this.errdisplay = true;
        this.errormsg.push("Please enter MOS/AFSC/Rating.");
      }*/
      if (!(this._parent.model.zip_code)) {
        this.errdisplay = true;
        this.errormsg.push("Please enter zip code.");
      }
      if (!(this._parent.model.email)) {
        this.errdisplay = true;
        this.errormsg.push("Please enter email.");
      }
      if ((this._parent.model.email) && !filter.test(this._parent.model.email)) {
        this.errdisplay = true;
        this.errormsg.push("Please enter valid email address.");
      }
      if ((this._parent.model.email) && filter.test(this._parent.model.email) &&  /\b\d*test\d*\b/gi.test(this._parent.model.email)) {
        this.errdisplay = true;
        this.errormsg.push("Email may not contain the word 'test'.");
      }
      if (!(this._parent.model.password)) {
        this.errdisplay = true;
        this.errormsg.push("Please enter password.");
      }
      /*if (!(this._parent.model.cpassword)) {
        this.errdisplay = true;
        this.errormsg.push("Please enter confirm password.");
      }*/
      if ((this._parent.model.password) && this._parent.model.password.length < 6) {
        this.errdisplay = true;
        this.errormsg.push("Length of password should be greater than 6.");
      }
      /*if ((this._parent.model.password) && (this._parent.model.cpassword) && (this._parent.model.password != this._parent.model.cpassword)) {
        this.errdisplay = true;
        this.errormsg.push("Password Mismatch.");
      }
      if($('#password').val().length < 6){
        this.error = "Length of password should be greater than 6.";
      }else{
        this.error = "";
      }*/
      this.formClass = "validate";
    }
  }

  async accountsubmit() {
    this.isLoader = true;
    let currentUrl = window.location.href;
    let urlData = currentUrl.split("/");
    let secondaryUrl = "";
    if (urlData[3]) {
      if (urlData[3] == "calcmatch") {
        secondaryUrl = "/register/request-info/calcmatch/"+this._parent.model.calmatchSrc+"/" + this.collegeName[0].college_name;
      } else {
        let sourceUrl = urlData[3].split("&");
        if(sourceUrl[0] == "?utm_source=bold" && sourceUrl.length == 4){
          let subIdData = sourceUrl[3].split("=");
          this._parent.model.subId = subIdData[1];
          secondaryUrl = "/register/utmsource/bold";
        }else{
          secondaryUrl = "/register/request-info/" + urlData[3];
        }
      }
    } else {
      secondaryUrl = "/register/request-info";
    }
    if(this._parent.model.secondary_source === undefined) {
      this._parent.model.secondary_source = secondaryUrl;
    }
    this._parent.model.primary_source = "program matcher";
    //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 5);
    this._parent.model.site_source = this.siteSrc;
    let checkMS = this.militaryStatusInfo(this._parent.model.military_status);
    
    if(checkMS != -1){
      this._parent.model.military_rank = "";
      this._parent.model.mos = "";
    }

    if (this._parent.model.secondary_bucket.length == 0) {
      let secBucket = await this._services.getList('/secondarybucketlist/' + this._parent.model.bucket_id)
        secBucket.forEach(data => {
          this._parent.model.secondary_bucket.push({
            id: data.secBucketId,
            name: data.secBucketTitle
          }) 
        })
      this._parent.model.secondary_bucket_ids = this._parent.model.secondary_bucket.map(a => a.id).join(',');
    }
    
    this.resultData = await this._services.post('/search/crud', this._parent.model);
    if (this.resultData.toString() == "userexist") {
      this.isLoader = false;
      //this.error = "User Exist with email " + this._parent.model.email;
      this.error = "A user with this email already exists in our records. Please log-in instead.";
    } else if (this.resultData['uuid']) {
      this.saveFiltertracking(this._parent.model);
      this._parent.model.uuid = this.resultData['uuid'];
      let collegesData = await this._services.post('/search/matchdata', this._parent.model);
      //bounce email sending function
      let secBucketDataToEmail = {
        areaOfFocus: this._parent.model.secondary_bucket.map(x=> x.name )
      }
      let bounceData = [this._parent.model.email,this._parent.model.first_name,this.resultData['uuid'],this._parent.model.study_state_values,"",this._parent.model.bucket_text,secBucketDataToEmail, collegesData,'register',this._parent.model.military_status];
      let emmm = await this._services.post('/emailbounceback/autosendemail/newuser', bounceData);
      //Degree bounce email
      let primaryArray = ['4','6','8','10','11','12','13','17','18','19'];
      if(this._parent.model.bucket_id.indexOf(",") > -1){
        let priData = this._parent.model.bucket_id.split(",");
        for(let j=0;j<priData.length;j++){
          if(primaryArray.indexOf(priData[j]) > -1){
            this.sendBounceBackEmail(priData[j]);
          }
        }
      }else{
        if(primaryArray.indexOf(this._parent.model.bucket_id) > -1){
          this.sendBounceBackEmail(this._parent.model.bucket_id);
        }
      }
      //console.log("Email s:",emmm);
      //end bounce email
      this.saveSearchresultTracking(this._parent.model, collegesData);
      let matchData = {
        "studentId": this.resultData['uuid'],
        "passed_cid": this._parent.model.passedIn_college_id,
        "collegeData": collegesData,
        "src": "Flow",
        "contacted": "No"
      }
      // console.log("MM:", matchData);
      await this._services.post('/flow/match/save/collegelist', matchData);
      this.isLoader = false;
      this._parent.index++;
      localStorage.setItem("NewUserRegister", 'true');
    }
  }
  prevAction() {
    this._parent.index--;
  }

  async saveFiltertracking(trackdata) {
    // track major data
    let majordata = trackdata.secondary_bucket;
    for (let index = 0; index < majordata.length; index++) {
      let trackData = {
        "primarySource": "program matcher",
        "secondarySource": "register",
        "filterType": "secondary bucket",
        "value": majordata[index]['id']
      }
      await this._services.post('/college/filter/tracking', trackData);
    }
    // track state data
    let statedata = trackdata.study_state;
    for (let index = 0; index < statedata.length; index++) {
      let trackData1 = {
        "primarySource": "program matcher",
        "secondarySource": "register",
        "filterType": "state",
        "value": statedata[index]['value']
      }
      await this._services.post('/college/filter/tracking', trackData1);
    }
    // track level data
    let trackData2 = {
      "primarySource": "program matcher",
      "secondarySource": "register",
      "filterType": "level",
      "value": trackdata.education_goal
    }
    await this._services.post('/college/filter/tracking', trackData2);
    // track bucket data
    let trackData3 = {
      "primarySource": "program matcher",
      "secondarySource": "register",
      "filterType": "bucket",
      "value": trackdata.bucket_id
    }
    await this._services.post('/college/filter/tracking', trackData3);
  }

  async saveSearchresultTracking(trackdata, collegeinfo) {
    let trackData = {
      "primarySource": "program matcher",
      "secondarySource": "register",
      "filters": JSON.stringify(trackdata),
      "collegeList": collegeinfo.map(a => a.collegeId).join(',')
    }
    await this._services.post('/searchresult/colleges/tracking', trackData);
  }

  async sendBounceBackEmail(bucketId){
    let bounceBackData = {
      "education_goal" : this._parent.model.education_goal,
      "area_focus_length" : this._parent.model.secondary_bucket.length,
      "college_id": 0,
      "state": this._parent.model.study_state_values,
      "bucket_id": bucketId,
      "area_focus_ids": this._parent.model.secondary_bucket_ids,
      "military_status": this._parent.model.military_status
    };
    let bucketInfo = this._parent.model.primary_bucket.find(obj => obj.id === parseInt(bucketId));
    let bucketTitle = bucketInfo.name;
    let bounceDegreeData = [bounceBackData,this._parent.model.email,this._parent.model.first_name,this._parent.model.uuid,bucketTitle,this._parent.model.secondary_bucket.map(x=> x.name).join(','),'register'];
    let bbounce = await this._services.post('/emailbounceback/match/bucketdata', bounceDegreeData);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/account/account.component.ts